import { render } from "./Variety_detail.vue?vue&type=template&id=8b1986bc&scoped=true"
import script from "./Variety_detail.vue?vue&type=script&lang=js"
export * from "./Variety_detail.vue?vue&type=script&lang=js"

import "./Variety_detail.vue?vue&type=style&index=0&id=8b1986bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b1986bc"]])

export default __exports__